
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqzOU74ZxtAQQPNDxCegpU_5ePFJbL8jq7tZUzM1NW4wEMeta } from "/codebuild/output/src3378769998/src/src/pages/faq.vue?macro=true";
import { default as menudkJnXYro_45a786Ip7WdZUcZ6nxLaaOvM_45lzbzwux9E84Meta } from "/codebuild/output/src3378769998/src/src/pages/menu.vue?macro=true";
import { default as indexDeKo4Kf0Kb0eRKtXA__sO8avQQf4BgSjeADeT7VZulgMeta } from "/codebuild/output/src3378769998/src/src/pages/index.vue?macro=true";
import { default as contactz9uVtldG1gSd9KF72peNZsMRhmgTE9W5i6oVpbfCoXQMeta } from "/codebuild/output/src3378769998/src/src/pages/contact.vue?macro=true";
import { default as tutorialJ8ixwFkswSQOWwwGuG2pFF_rB8H8EaVYPFWOBBb0l6QMeta } from "/codebuild/output/src3378769998/src/src/pages/tutorial.vue?macro=true";
import { default as agreementhdBBIhFgSPEtpL7pUGMf0d_o6nPNApoXHiU_4578FvcRUMeta } from "/codebuild/output/src3378769998/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass27gcQ0LOCaujx98CuX9bL9AN3Zpe7WvZDBGCe_45X_4R8Meta } from "/codebuild/output/src3378769998/src/src/pages/about-pass.vue?macro=true";
import { default as indexDBoNkH8aHQmZcciJrlCUGK5igk1HiM8EiBUVP9C1k2QMeta } from "/codebuild/output/src3378769998/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93agkM5JF6d3p3CY6lQHtOpqylqce93qMy_DJSeQsFgHoMeta } from "/codebuild/output/src3378769998/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceQ_455vY7h2v_ChSrfYU8YUaaL_45Q3HcV5ZPEQagyJ8apesMeta } from "/codebuild/output/src3378769998/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93sYGY7WSbT_Y47ChZmnBnayRWC5cx4KRnl2M_45Opig6PkMeta } from "/codebuild/output/src3378769998/src/src/pages/notice/[id].vue?macro=true";
import { default as indexW60uSo6Vqf1s2MEnFMqICYTtvGhyFXYTu6h7y0L5eRsMeta } from "/codebuild/output/src3378769998/src/src/pages/coupon/index.vue?macro=true";
import { default as indexBLR2G9xAZ_3Dd3PTFI6oy0jG__yxqVOI7qPvR8GmQIcMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/index.vue?macro=true";
import { default as index6jjDU7brWlJO_45EcSr6YJLfZEeNpL_45R1aQQuBuouI7FoMeta } from "/codebuild/output/src3378769998/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93aCt6TDlnajC66P1UjqPqKTja4DqqbX9CH4I8747Fr_45kMeta } from "/codebuild/output/src3378769998/src/src/pages/parking/[id].vue?macro=true";
import { default as indexXDEbyWTqP8spggGBA1O1vG9LTnYeZWAlorPO3NMC6i0Meta } from "/codebuild/output/src3378769998/src/src/pages/history/index.vue?macro=true";
import { default as indexQgcbjZdJFetjZXREnCB_45Wt_45g8P3K0UaPLl6V_45b8Ofw0Meta } from "/codebuild/output/src3378769998/src/src/pages/monthly/index.vue?macro=true";
import { default as indexSSeSGHL9xUbBGpObWbqK2rdpd5AzG_XO_hBUogXjVmsMeta } from "/codebuild/output/src3378769998/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexSlz7LTTbJ40LeeM6Hc5DAu2CBtIT8mRhDA7oLvK06eEMeta } from "/codebuild/output/src3378769998/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviDhqFP5FcXHl5jnp_457q_45TazR_45YZdN9hsFUde_45H7Rtsu4Meta } from "/codebuild/output/src3378769998/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit4BBRR4EtcIfci_45wChs9qwAWD4HdyyGuqlpi2E9cXnfMMeta } from "/codebuild/output/src3378769998/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementSIl6AL4SKUJD78kXsy9Mhl_DhjHfcYcf_nSV9Aq6d7EMeta } from "/codebuild/output/src3378769998/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexOl1Wq2RrBQh3LId1cDgv339QeqHtXhYiprD5uq4AbYMMeta } from "/codebuild/output/src3378769998/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dozsGgO1SA_451HH1NUpKCwNe1eJ_45lqwcZqD23B4_4509F10Meta } from "/codebuild/output/src3378769998/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmGHFfRIlOHxTi8OiDeFEAnE6UYnMJOueB_6TsIVwk6ggMeta } from "/codebuild/output/src3378769998/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index2wqIctKH0VmxWoxk3_45xpabs4euMF4zb0_45ctOeWpN1e0Meta } from "/codebuild/output/src3378769998/src/src/pages/card/create/index.vue?macro=true";
import { default as index5XDg7oV4u8IOkFZYoTqqUZA50hKiu2n_BE9hQFPxxKwMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmCe46d25ZOxKYYIOeamWNQ6gJrYkiDhkFe3yXJKk2xNgMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmrSsldCZpc7WRL12eKtd4QAO_450XrZrilc0GRxOmrlKa8Meta } from "/codebuild/output/src3378769998/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete0uO3yFB8ehjBRMFv4epdtMa9L8Mh__45_455Jaj_456lNF1qgMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/complete.vue?macro=true";
import { default as register1499cZjq05FEif23a0ADW88WckpNa5ldKbJHuBaZO8EMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93i8qj1Nu_45lwE9B3X8kj_Wq94gQDZwuGqXQYV1YPQ3Cv0Meta } from "/codebuild/output/src3378769998/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmcuUlhMHPH4BlqOewxfPr2z2DxGKXLEOwAak8_45f2_eagMeta } from "/codebuild/output/src3378769998/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93e3HqKD97Qlugt2hCQZfT8KRAajBObGWjB8Zz4eZDVwsMeta } from "/codebuild/output/src3378769998/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexwv2xdsQ0fiR6T9obTu_fdGCAYTxj52RUhroybytQx4kMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code8EKpDkEmRHNMY_NsqRVcB3iw2UW5L5dZ_45pEkxUFaEPIMeta } from "/codebuild/output/src3378769998/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeO6c7taNDT7sZg_454dSFEc9WMF9bjG_45mzL_45bxVyTkH9egMeta } from "/codebuild/output/src3378769998/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeFUTU_BqILJi7zNQWdc9WptTk_pgP6Fgrsoy_45ThF2AwMMeta } from "/codebuild/output/src3378769998/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerssef1W7GZ7MW_45jTWhggrApOWCqpUXElZbfPUH5iUZ6AMeta } from "/codebuild/output/src3378769998/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete_WQYCdKqlz6FwaBkPmzeaZK_cnDE4ZbMdclr7YQLKhoMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index089PxddxpmK7vcLojS8Pu_jW66zuS6p_459CAyEkOjym0Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmXd4xZwNCwQNhonYWUiGUhkeNGeObUQTNuCT9VpG8OHoMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeYBFQ3McfIYiA2xYP2w4ZN48P3XtSoEAt_vJL60SavqIMeta } from "/codebuild/output/src3378769998/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexlrQkdJ87upaHoxXmqoXB_b5Q17jTvsfw4gsyJYkSGAkMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93i3T3Ny20AGtXsmBMZCV9n4ETbXbD0HGxm0dn9IFoo9EMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeHkBHwMBCrUVfLpY8HZ9u1Y2WuvGT1mlj3lOC3mQXpK0Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias6f06PYLTD62_45IBl_4592I67ab_45MBkO2AevK267Zv_9_1gMeta } from "/codebuild/output/src3378769998/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleYIcO9R7AD3LbHZju96xXu2dFa93uMzJrfzenIUwGI38Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email4xby6BiNvHHOoDgPoov_xd6XWpfU69toCB43435ClD8Meta } from "/codebuild/output/src3378769998/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmzIKUB1ImGm0Us9hOi8ewpEFb9l_9WAZbiF_oWqSL_45bMMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent5gKIJsOpHbUf0Mzcb2RYi7CvU2eNTMIrLYj4QCwKUa4Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmwoq_uu5_ZR8qFXTAwHffTRymLOfT_45MXCvTSr9DE96CMMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate7XLZamzDOCHOSbNh66oDbhv6YX0Jx9GTMmPFOO_2AngMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeL6HahtYBlUcp3pa4tB6Nh7h6E38YNWd1XmB_45dIhKyX4Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code8BiPifcP8OwsmwrLaCmkliAjZIATTNVgruMK3u_k_45AcMeta } from "/codebuild/output/src3378769998/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhlz3qRilaUoSoPNaQLvrQ1BZyQrGyfRLy9Tl8qruiNsMeta } from "/codebuild/output/src3378769998/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasrhOAFr8uDe_45ozeRa9qqY2uJ4N0B6mur6OblmFCnFSksMeta } from "/codebuild/output/src3378769998/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerIccOAXmxjHhpxtuWCttN1gidKUAIs7qVKWwGIuDLAxYMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code27Vnq_455B6x8mJVDKKlNcDv4FW5Tsl9eHdRoVU05KJtIMeta } from "/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexTxTrZptqDel29TNOTuDIJk0vChyc_f7P0AGP_45zMo8AwMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indextq8LRe8_7wd8DXibDIojXpvZNaqKd0OYBkf0a_auLy4Meta } from "/codebuild/output/src3378769998/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexFVqP7z9_45ekncR_45KzTJq4sRBpXlVxsokUaNnirNiotCcMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexxuqNRJFGU7ASy8VR3xQtqxS3h_45Ds9hu_45m8hvegyyQjsMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatev86zEgp9Iz5rvlvQ1e7cA7fGNADSUwm8dOBr0Jx5hHAMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeIt2dobrNxmZjuuih7yGsr2X64y_45_45fvC9fV13mEx0ZvIMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm8otoN7v_457pU6EPMx9I9kY_u7F2ixKNz4NpmFMNvzEy8Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexLn68zl6JIZQyFt4ufLdGAqqCQicvT1MWeQj0jHpU4ecMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completePOvikVkdPlti2OYn615skauNlXzJHAwusV7r_UTGJvkMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateB2n75EYofH7GEnpJktqHePB_45B4RKupn0O1TxCvKRS00Meta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexPhZ5nuJqjeaY_Zo2JuuaCMqubQrUvwYXNnfSp77ZSzEMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexjeUMlmaXrjUN21G9YhzYaRSktRW_dXjhVkeYlvYkTeMMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completevhXtqc6grsLPybhfPglKeQILps7YQKGF4WkgakCGY_wMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexoa7lGswbMxBFl4Zz4NsZFWUfMDyMR8Ovw5pt1dIsgeAMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code3HOedtMzvR_PeCA5mUYKLxzRX5S6ccqBXWpjY03Br_45gMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index1KMbTgpJ844K3g4BWCT0ox3_ZkKRZKXWBtrgUCx71fUMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexsesjeIcCflavqYPPZl2Ks3O8tXdj_45jlU_45dW0aK34gB0Meta } from "/codebuild/output/src3378769998/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index8CHtYhm2XvN78_tsjyWYsC7P_3rSt2RO2bTiBCE3meMMeta } from "/codebuild/output/src3378769998/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatefcG7E1Ik6L_yMtv84Z9uqS3CET_28vuZXHsRTsy_45R4oMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmvpNirwVK0lB6AcF0TeFfxeNXxtacUpDFuc9dAdI8HOcMeta } from "/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menudkJnXYro_45a786Ip7WdZUcZ6nxLaaOvM_45lzbzwux9E84Meta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexDeKo4Kf0Kb0eRKtXA__sO8avQQf4BgSjeADeT7VZulgMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexW60uSo6Vqf1s2MEnFMqICYTtvGhyFXYTu6h7y0L5eRsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexXDEbyWTqP8spggGBA1O1vG9LTnYeZWAlorPO3NMC6i0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexSSeSGHL9xUbBGpObWbqK2rdpd5AzG_XO_hBUogXjVmsMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexSlz7LTTbJ40LeeM6Hc5DAu2CBtIT8mRhDA7oLvK06eEMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index2wqIctKH0VmxWoxk3_45xpabs4euMF4zb0_45ctOeWpN1e0Meta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmCe46d25ZOxKYYIOeamWNQ6gJrYkiDhkFe3yXJKk2xNgMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmrSsldCZpc7WRL12eKtd4QAO_450XrZrilc0GRxOmrlKa8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete0uO3yFB8ehjBRMFv4epdtMa9L8Mh__45_455Jaj_456lNF1qgMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register1499cZjq05FEif23a0ADW88WckpNa5ldKbJHuBaZO8EMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmcuUlhMHPH4BlqOewxfPr2z2DxGKXLEOwAak8_45f2_eagMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code8EKpDkEmRHNMY_NsqRVcB3iw2UW5L5dZ_45pEkxUFaEPIMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeO6c7taNDT7sZg_454dSFEc9WMF9bjG_45mzL_45bxVyTkH9egMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeFUTU_BqILJi7zNQWdc9WptTk_pgP6Fgrsoy_45ThF2AwMMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerssef1W7GZ7MW_45jTWhggrApOWCqpUXElZbfPUH5iUZ6AMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmXd4xZwNCwQNhonYWUiGUhkeNGeObUQTNuCT9VpG8OHoMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeYBFQ3McfIYiA2xYP2w4ZN48P3XtSoEAt_vJL60SavqIMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexlrQkdJ87upaHoxXmqoXB_b5Q17jTvsfw4gsyJYkSGAkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeHkBHwMBCrUVfLpY8HZ9u1Y2WuvGT1mlj3lOC3mQXpK0Meta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleYIcO9R7AD3LbHZju96xXu2dFa93uMzJrfzenIUwGI38Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email4xby6BiNvHHOoDgPoov_xd6XWpfU69toCB43435ClD8Meta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmzIKUB1ImGm0Us9hOi8ewpEFb9l_9WAZbiF_oWqSL_45bMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent5gKIJsOpHbUf0Mzcb2RYi7CvU2eNTMIrLYj4QCwKUa4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmwoq_uu5_ZR8qFXTAwHffTRymLOfT_45MXCvTSr9DE96CMMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeL6HahtYBlUcp3pa4tB6Nh7h6E38YNWd1XmB_45dIhKyX4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code8BiPifcP8OwsmwrLaCmkliAjZIATTNVgruMK3u_k_45AcMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhlz3qRilaUoSoPNaQLvrQ1BZyQrGyfRLy9Tl8qruiNsMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerIccOAXmxjHhpxtuWCttN1gidKUAIs7qVKWwGIuDLAxYMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code27Vnq_455B6x8mJVDKKlNcDv4FW5Tsl9eHdRoVU05KJtIMeta || {},
    component: () => import("/codebuild/output/src3378769998/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3378769998/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]